import React, { useState } from "react";
import { Card, Button, ButtonGroup, Modal, Carousel } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoIosAppstore } from "react-icons/io";
import { Link } from "react-router-dom";
import screenshot1 from "../../Assets/Projects/purpletrap/01_title.png";
import screenshot2 from "../../Assets/Projects/purpletrap/02_gameplay.png";
import screenshot3 from "../../Assets/Projects/purpletrap/03_game_over.png";

const translations = {
  tr: {
    title: "PurpleTrap",
    description: "Renkli kareleri hizalayarak patlamalar yarat ve geri sayımları sıfırlamadan önce ekranı temizle! Üzerinde sayı olan mor ve pembe kareler her hamlede azalır; sıfıra ulaşırsa oyun biter. Hızlı düşünme gerektiren, bağımlılık yapıcı bir bulmaca oyunu.",
    details: "Detaylar",
    privacy: "Gizlilik Politikası",
    terms: "Kullanım Şartları",
    modalTitle: "PurpleTrap - Detaylı Bilgi",
    features: [
      "🟣 Renk Eşleştirme: Aynı renkteki kareleri patlat",
      "⏱️ Geri Sayım Tuzakları: Sayaçlı karelere dikkat et",
      "🏆 Yüksek Skor: Rekorunu kırmaya çalış",
      "🥇 Liderlik Tablosu: Game Center ile küresel rekabet",
      "📤 Skor Paylaşımı: Başarını arkadaşlarınla paylaş",
      "🚫 Reklamsız Mod: Tek seferlik satın alma ile reklamları kaldır",
      "📱 iOS üzerinde ücretsiz"
    ]
  },
  en: {
    title: "PurpleTrap",
    description: "Line up colored tiles to trigger explosions and clear the board before the countdown traps hit zero! Numbered purple and pink tiles tick down with every move — let them reach zero and it's game over. A fast, addictive puzzle game.",
    details: "Details",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    modalTitle: "PurpleTrap - Detailed Information",
    features: [
      "🟣 Color Matching: Pop tiles of the same color",
      "⏱️ Countdown Traps: Watch out for numbered tiles",
      "🏆 High Score: Chase your personal best",
      "🥇 Leaderboard: Compete globally via Game Center",
      "📤 Share Score: Brag to your friends",
      "🚫 Ad-Free Mode: One-time purchase removes ads",
      "📱 Free on iOS"
    ]
  }
};

const screenshots = [screenshot1, screenshot2, screenshot3];

function PurpleTrapCard({ imgPath }) {
  const [language, setLanguage] = useState("tr");
  const [showModal, setShowModal] = useState(false);
  const content = translations[language];

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={imgPath} alt="card-img" />
        <Card.Body>
          <div style={{ marginBottom: "15px" }}>
            <ButtonGroup size="sm">
              <Button
                variant={language === "tr" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("tr")}
              >
                TR
              </Button>
              <Button
                variant={language === "en" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("en")}
              >
                EN
              </Button>
            </ButtonGroup>
          </div>
          <Card.Title>{content.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {content.description}
          </Card.Text>
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
          >
            <AiOutlineInfoCircle /> &nbsp;
            {content.details}
          </Button>
          <Button
            variant="primary"
            href="https://apps.apple.com/app/purpletrap/id_PLACEHOLDER"
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <IoIosAppstore /> &nbsp;
            App Store
          </Button>
          <div style={{ marginTop: "10px" }}>
            <Button
              variant="outline-primary"
              as={Link}
              to="/privacy-policy/purpletrap"
              size="sm"
              style={{ marginRight: "5px" }}
            >
              {content.privacy}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/terms-of-service"
              size="sm"
            >
              {content.terms}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/support/purpletrap"
              size="sm"
              style={{ marginLeft: "5px" }}
            >
              {language === "tr" ? "Destek" : "Support"}
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#1a1a2e", color: "white" }}>
          <Modal.Title>{content.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#16213e", color: "white" }}>
          <Carousel>
            {screenshots.map((screenshot, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={screenshot}
                  alt={`Screenshot ${index + 1}`}
                  style={{ maxHeight: "500px", objectFit: "contain" }}
                />
              </Carousel.Item>
            ))}
          </Carousel>

          <div style={{ marginTop: "20px" }}>
            <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>
              ✨ {content.modalTitle.split(" - ")[1]}
            </h5>
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {content.features.map((feature, index) => (
                <li key={index} style={{ marginBottom: "10px", fontSize: "16px" }}>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#1a1a2e", borderTop: "1px solid #c770f0" }}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PurpleTrapCard;
